import { useEffect, useState, useRef } from 'react';

export const useCountUp = (
  target: number,
  duration: number = 3000,
  startOnMount: boolean = true
) => {
  const [current, setCurrent] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const previousTarget = useRef(0);

  const startAnimation = (from: number, to: number) => {
    if (isAnimating) return;
    
    setIsAnimating(true);
    
    const startTime = Date.now();
    const difference = to - from;
    
    const animate = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      if (progress >= 1) {
        setCurrent(to);
        setIsAnimating(false);
        previousTarget.current = to;
        return;
      }
      
      // Use easing for smooth animation
      const easeOutQuart = 1 - Math.pow(1 - progress, 3);
      const value = Math.floor(from + (easeOutQuart * difference));
      
      setCurrent(value);
      requestAnimationFrame(animate);
    };
    
    requestAnimationFrame(animate);
  };

  useEffect(() => {
    if (target !== previousTarget.current) {
      if (startOnMount) {
        const timer = setTimeout(() => {
          startAnimation(previousTarget.current, target);
        }, 100);
        return () => clearTimeout(timer);
      } else {
        startAnimation(previousTarget.current, target);
      }
    }
  }, [target, startOnMount]);

  return { current, startAnimation: () => startAnimation(previousTarget.current, target), isAnimating };
};